import { useState } from "react";
import { X } from "lucide-react";
import { resolveMediaUrl, handleMediaError } from "@/lib/media";

// Kept as an alias for existing imports; delegates to the central resolver.
export const resolveImg = resolveMediaUrl;

export default function ReviewGallery({ images = [], size = "md" }) {
  const [active, setActive] = useState(null);
  if (!images?.length) return null;
  const dim = size === "sm" ? "h-14 w-14" : "h-16 w-16 sm:h-20 sm:w-20";
  return (
    <>
      <div className="flex flex-wrap gap-2 mt-2" data-testid="review-gallery">
        {images.map((img, i) => {
          const url = resolveMediaUrl(img.url || img);
          return (
            <button key={i} type="button" onClick={() => setActive(url)} data-testid={`review-image-${i}`}
              className={`${dim} rounded-lg overflow-hidden border border-slate-200 bg-slate-50 hover:border-amber-400 transition`}>
              <img src={url} alt={`Review ${i + 1}`} loading="lazy" onError={handleMediaError} className="w-full h-full object-cover" />
            </button>
          );
        })}
      </div>
      {active && (
        <div className="fixed inset-0 z-[60] grid place-items-center p-4 bg-slate-900/80" onClick={() => setActive(null)} data-testid="review-lightbox">
          <button className="absolute top-4 right-4 text-white/80 hover:text-white" onClick={() => setActive(null)} aria-label="Close"><X className="h-7 w-7" /></button>
          <img src={active} alt="Review" onError={handleMediaError} className="max-h-[85vh] max-w-full rounded-lg object-contain" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </>
  );
}
